export default {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    companyName: '',
    fleetSize: '',
    state: '',
    country: '',
}
